module.exports = __webpack_public_path__ + "static/media/logout.549b8cce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/logout.svg
// module id = 309
// module chunks = 0